import { Component, Input } from '@angular/core';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { ScoreService } from '../../match-tracker/tracker-board/services/score.service';
import { PartnerConnectService } from '../../_core/services/partner-connect.service';
import { Match } from '../../_shared/models/match.model';
import { ScoreFormat } from '../../_shared/models/score-format.model';

@Component({
  standalone: false,
    selector: 'app-score-display',
    templateUrl: './score-display.component.html',
    styleUrls: ['./score-display.component.scss'],
})
export class ScoreDisplayComponent {
    @Input() match: Match;
    @Input() showPoints: boolean;
    @Input() sideNumber: number;

    constructor(
        private bhs: BoardHelpService,
        private pcs: PartnerConnectService,
        private scoreService: ScoreService
    ) { }

    getPointScore() {
        return this.match.sets.length
            ? this.bhs.getPointScore(this.match, this.sideNumber)
            : '';
    }

    getTiebreakScore(setIndex: number) {
        if (!this.scoreService.isMatchCompletedAndLastSetTiebreak(this.match, setIndex)) {
            return this.match.score?.sets?.length
                ? this.sideNumber === 1
                    ? this.match.score.sets[setIndex]?.side1TiebreakScore
                    : this.match.score.sets[setIndex]?.side2TiebreakScore
                : this.pcs.getTiebreakScore(this.match.sets[setIndex], this.sideNumber);
        } else {
            return null;
        }

    }

    isLastSetTiebreakPlayed(setIndex): boolean {
        const scoreFormat: ScoreFormat = this.bhs.getScoreFormat(this.match.matchFormat, this.match.discipline);
        if (scoreFormat.numberOfSets === setIndex + 1 && this.match.sets[setIndex].setFormat === 'TIEBREAK' && scoreFormat.lastSetTiebreakTo > 0) {
            return true;
        }
        return false;
    }

}
